module.exports = __webpack_public_path__ + "media/images/about/c_1-97ac7fd691524b8d8a823d2ce64624b5.png";